<template>
  <div
    v-scroll="handleScrollPosition"
  >
    <div class="d-flex align-center">
      <v-btn
        small
        class="primary ml-3 mt-3"
        @click="$emit('detail', {id: null})"
      >
        <v-icon
          class="mr-3"
        >mdi-plus
        </v-icon>
        Добавить клиента
      </v-btn>
      <Controls
        :filters="value.requestParams.filters"
        @input="handleControls($event)"
        @list="$emit('list', $event)"
        :loading="loadingTable"
      />
    </div>
    <Table
      :options="value.requestParams.options"
      @input="localRequestParams.options = $event"
      :loading="loadingTable"
      :items="items"
      :items-length="itemsLength"
      :opened.sync="localState.openedItems"
      @detail="$emit('detail', $event)"
    />
  </div>
</template>

<script>
import Table from './List/Table'
import Controls from './List/Controls'
import list from '@/components/mixins/list'

export default {
  mixins: [list],
  name: 'List',
  components: { Table, Controls },
  data () {
    return {
      fillTableUrl: '/client'
    }
  }
}
</script>

<style scoped>

</style>
